var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCostaRica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m815.72 242.49c37.52 19.578-29.836 43.609 89.512 169.84 119.35 126.23 224.93 220.34 234.11 257.06 9.1797 36.723-80.332 6.8867-82.625 82.625-2.2969 75.742 43.609 45.902 13.77 126.23-29.836 80.332-45.902 218.04-78.035 206.57-32.133-11.477-36.723-117.05-89.512-123.94-52.789-6.8867-66.559 4.5898-50.492 32.133 16.066 27.543 11.477 43.609-27.543 27.543-39.02-16.066-84.922-32.133-75.742-64.266 9.1797-32.133 75.742-45.902 59.676-105.58-16.066-59.68-289.19-128.54-335.09-181.32-45.902-52.789-22.953-137.71-78.035-169.84-55.086-32.133-126.23-84.922-140-52.789-13.77 32.133 130.82 98.691 94.102 142.3-36.723 43.609-50.492 52.789-89.512 18.359-39.02-34.426-167.55-36.723-195.09-123.94-27.543-87.215 64.266-121.64 43.609-169.84-20.66-48.199-71.152-91.805-32.137-156.07 39.02-64.266 140.01-45.902 206.57-13.77 66.559 32.133 156.07 2.2969 222.63 13.77 66.559 11.477 87.215 96.398 146.89 98.691 59.672 2.2969 110.17-41.312 162.96-13.77z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostaRica);
export default __webpack_public_path__ + "static/media/costaRica.5112b4ff921ec841a277eab32c0764ad.svg";
export { ForwardRef as ReactComponent };